/** @format */

import React from "react";
import { Helmet } from "fusion-plugin-react-helmet-async";
import { assetUrl } from "fusion-core";
import { useNavigate } from "fusion-plugin-react-router";
import {
  downloadComplaintPolicy,
  downloadCookiePolicy,
  downloadPrivacyPolicy,
  downloadTOBA,
} from "../utils/apiUtils";

const Footer = () => {
  const navigate = useNavigate();

  const css = assetUrl("../../styles/main.css");
  return (
    <>
      <Helmet>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
        />
        <link rel="stylesheet" href={css} />
      </Helmet>

      <footer className="footer">
        <p className="footer-text">
          Uber Affinity UK Limited are an Appointed Representative of Freeway UK
          Insurance Services Limited trading as Driver Insurance Services,{" "}
          <a href="https://driver-insurance.co.uk" target="_blank">
            www.driver-insurance.co.uk
          </a>{" "}
          , Freeway. Freeway UK Insurance Services Ltd are authorised and
          regulated by the Financial Conduct Authority (FCA) under firm
          reference number 306626. You may check this on the Financial Services
          Register by visiting the FCA's website,{" "}
          <a href="https://register.fca.org.uk/s/" target="_blank">
            www.register.fca.org.uk
          </a>{" "}
          or by contacting the FCA on 0800 111 6768. Company is Registered in
          England No. 04030245. | All Rights Reserved
        </p>
        <p className="footer-text">
          Unit 4, Abbots Park Monks Way, Preston Brook, Runcorn, Cheshire,
          England, WA7 3GH
        </p>
        <div className="footerTermsContainer">
          <button onClick={() => downloadTOBA({ navigate })}>
            Terms of business
          </button>
          <span>|</span>
          <button onClick={() => downloadPrivacyPolicy({ navigate })}>
            Privacy Policy
          </button>
          <span>|</span>
          <button onClick={() => downloadCookiePolicy({ navigate })}>
            Cookies Policy
          </button>
          <span>|</span>
          <button onClick={() => downloadComplaintPolicy({ navigate })}>
            Complaints Policy
          </button>
        </div>
      </footer>
    </>
  );
};

export default Footer;
